//
// class for date data type
//
// @extends [DataFormatterType]
//
import { DataFormatterType } from '../DataFormatterType';
import { DataFormatterOptions } from '../DataFormatterType';
import { DataTools } from '../../utils/DataTools';

/**
 * Data formatter for general date types
 * @ignore
 */
export class DataFormatDateTime extends DataFormatterType
{
    constructor(...args: any[])
    {
        super();
    }

    getName(): string
    {
        return "datetime";
    }

    /* Return option text to the right of the display value */
    getUnitText(options?: DataFormatterOptions): string
    {
        return "";
    }

    /* Default options for the date formatter */
    initializeOptions(): DataFormatterOptions
    {
        return {
        }
    }

    /**
     * funtion to format the currently passed data
     *
     * @param {object} data data to be formatted
     * @param {object} options additonal options defined for the datatype
     * @param {string} path path where the value is being edited
     * @return {object} data formatted data
     */
    format(data: any, options: any)
    {
        if ((typeof options === "string") && (options[0] === "{"))
        {
            options = JSON.parse(options);
        }

        let format = "ddd, MMM Do, YYYY h:mm:ss A";
        if ((options != null) && (options.dateonly != null) && (options.dateonly === true))
        {
            format = "ddd, MMM Do, YYYY";
        }

        const m = DataTools.getMoment(data);
        if ((m == null))
        {
            return "";
        }

        return m.format(format);
    }

    /**
     * Format the data for export.  As this is a basic type, we want CSV files
     * to have the raw number value.
     *
     * @param {object} data
     * @param {object} options
     * @param {object} refObj
     */
    formatExport(data: any, options?: DataFormatterOptions, refObj?: any): any
    {
        return DataTools.getNumber(data);
    }

    getAlign(): string
    {
        return "right";
    }

    /**
     * funtion to unformat the currently formatted data
     * @param {object} data data to be unformatted
     * @return {object} data unformatted data
     */
    unformat(data: any, format?: string): Date | undefined
    {
        try
        {
            const m = DataTools.getMoment(data, format);
            if ((m == null))
            {
                return undefined;
            }

            return m.toDate();
        } catch {
            console.warn("DataFormatDateTime error, unable to unformat date value: ", data);
            return undefined;
        }
    }

}

export default DataFormatDateTime;
